import React, { createContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {session, auth} from '../utils/AuthSession'
import { API } from '../utils/api'
import { Api } from '../utils/apiServer'
export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const defaultPrimaryColor = process.env.REACT_APP_DEFAULT_PRIMARY_COLOR || '#2563eb'
    const [primaryColor, setPrimaryColor] = useState(defaultPrimaryColor);
    const [primaryColorHover, setPrimaryColorHover] = useState(defaultPrimaryColor);
    const [partnerLogo, setPartnerLogo] = useState('')
    const location = useLocation()

    useEffect(()=>{
        let isCurrent = true
        const currentSession = session()
        if(!currentSession){
            setPrimaryColor(defaultPrimaryColor)
            setPrimaryColorHover(defaultPrimaryColor)
            Api({
                access: 'none',
                method: API.PUBLIC_PARTNER.type,
                url: API.PUBLIC_PARTNER.url,
                reqBody: {}
            }).then((data) => {
                const logo = data?.data?.logo
                if (isCurrent) setPartnerLogo(typeof logo === 'string' ? logo : '')
            }).catch(() => {
                if (isCurrent) setPartnerLogo('')
            })
            return () => { isCurrent = false }
        }

        auth().then((data)=>{
            const partner = data?.data?.partner
            if(partner && isCurrent){
                setPrimaryColor(partner.primary_color || defaultPrimaryColor)
                setPrimaryColorHover(partner.primary_color_hover || partner.primary_color || defaultPrimaryColor)
                setPartnerLogo(partner.logo || '')
            }
        }).catch(()=>{})
        return () => { isCurrent = false }
    },[location.pathname, defaultPrimaryColor])

    useEffect(()=>{
        document.documentElement.style.setProperty('--primary-color', primaryColor || defaultPrimaryColor)
        document.documentElement.style.setProperty('--primary-color-hover', primaryColorHover || primaryColor || defaultPrimaryColor)
    },[primaryColor, primaryColorHover, defaultPrimaryColor])

    useEffect(() => {
        if (!partnerLogo) return

        let favicon = document.querySelector('link[rel="icon"]')
        if (!favicon) {
            favicon = document.createElement('link')
            favicon.rel = 'icon'
            document.head.appendChild(favicon)
        }
        favicon.href = partnerLogo

        const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]')
        if (appleTouchIcon) appleTouchIcon.href = partnerLogo
    }, [partnerLogo])

    return (
        <ThemeContext.Provider value={{ primaryColor, primaryColorHover, partnerLogo }}>
            {children}
        </ThemeContext.Provider>
    );
};
